import { activityHistoryActions } from '@store/reducers/manager/activityHistory/actions'
import {
  fetchActionsSaga,
  previewSaga,
  restoreSaga,
} from '@store/reducers/manager/activityHistory/sagas'
import { takeLatest } from 'redux-saga/effects'

function* activityHistorySaga() {
  yield takeLatest(activityHistoryActions.fetchActionsSaga, fetchActionsSaga)
  yield takeLatest(activityHistoryActions.previewSaga, previewSaga)
  yield takeLatest(activityHistoryActions.restoreSaga, restoreSaga)
}

export { activityHistorySaga }
